import { IAnalyticsEventBase } from './types';
import { useAnalyticsEffect } from './useAnalyticsEffect';

interface IProps {
  event: IAnalyticsEventBase;
}

/**
 * Helper component to emit an event if rendered. Useful for
 * places where the event is emitted if certain component is rendered
 */
const AnalyticsEventEmitter = ({ event }: IProps) => {
  useAnalyticsEffect((track) => {
    track(event);
  });
  return null;
};

export default AnalyticsEventEmitter;
